/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExpenseListResourceSummary
 */
export interface ExpenseListResourceSummary {
    /**
     * 
     * @type {string}
     * @memberof ExpenseListResourceSummary
     */
    projectTitle?: string;
    /**
     * 
     * @type {number}
     * @memberof ExpenseListResourceSummary
     */
    totalAmountReimbursed?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpenseListResourceSummary
     */
    totalAmountPending?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpenseListResourceSummary
     */
    statusSubmittedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpenseListResourceSummary
     */
    statusApprovedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpenseListResourceSummary
     */
    statusPaidCount?: number;
}

/**
 * Check if a given object implements the ExpenseListResourceSummary interface.
 */
export function instanceOfExpenseListResourceSummary(value: object): value is ExpenseListResourceSummary {
    return true;
}

export function ExpenseListResourceSummaryFromJSON(json: any): ExpenseListResourceSummary {
    return ExpenseListResourceSummaryFromJSONTyped(json, false);
}

export function ExpenseListResourceSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseListResourceSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'projectTitle': json['projectTitle'] == null ? undefined : json['projectTitle'],
        'totalAmountReimbursed': json['totalAmountReimbursed'] == null ? undefined : json['totalAmountReimbursed'],
        'totalAmountPending': json['totalAmountPending'] == null ? undefined : json['totalAmountPending'],
        'statusSubmittedCount': json['statusSubmittedCount'] == null ? undefined : json['statusSubmittedCount'],
        'statusApprovedCount': json['statusApprovedCount'] == null ? undefined : json['statusApprovedCount'],
        'statusPaidCount': json['statusPaidCount'] == null ? undefined : json['statusPaidCount'],
    };
}

export function ExpenseListResourceSummaryToJSON(value?: ExpenseListResourceSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectTitle': value['projectTitle'],
        'totalAmountReimbursed': value['totalAmountReimbursed'],
        'totalAmountPending': value['totalAmountPending'],
        'statusSubmittedCount': value['statusSubmittedCount'],
        'statusApprovedCount': value['statusApprovedCount'],
        'statusPaidCount': value['statusPaidCount'],
    };
}

